import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      <p class="mb-3">
        Есть в мировой культуре два великих примера великой любви мужчины и женщины; любви всемогущей, меняющей всю жизнь и весь мир с ней. 
        Один пример из Китая, другой – из Шотландии. 
        Рассмотрим их. 
      </p>
      
      <p class="mb-3">
        Император Сюань-цзун (685 — 762 гг.) полюбил наложницу Ян Гуй-фэй и ради неё забросил все государственные дела. 
        Страна пришла в упадок, на границе напали арабы, внутри начались мятежи и восстания крестьян. 
        Но император не обращал на это внимания: чтó ему страна, если рядом с ним прекрасная Ян Гуй-фэй! 
        Великая империя отдана взамен за любовь! 
        Такой цены не платил никто на свете. 
        Нет в мире любви сильнее, чем любовь императора Сюань-цзуна. 
      </p>
      
      <p class="mb-5">
        Но военачальник  Ань Лу-шань поднял восстание и легко захватил полуразрушенную страну. 
        Император и Ян Гуй-фэй бежали, но были захвачены в пути. 
        Воины обещали сохранить священную особу императора, но требовали казни Ян Гуй-фэй. 
        И император, чтобы сохранить свою ничтожную жизнь, сам затянул шёлковый шнурок на горле красавицы. 
        Ради любви можно пожертвовать огромной страной; но СВОЕЙ жизнью?! 
        Да пропади они пропадом, эта красавица и эта любовь, если за них нужно платить жизнью! 
        Такова была великая любовь Сюань-цзуна.
      </p>
      
      <p class="mb-3">
        Девушка Дженет полюбила рыцаря Темлина, превращённого королевой фей в эльфа. 
        Он просил спасти его, освободить от власти королевы и вернуть ему облик человека. 
        Королева согласилась с одним условием: чтобы Дженет держала его в своих объятиях и не отпускала, какой бы вид он ни принимал. 
      </p>
      <p class="mb-3">
        Королева обладала огромной магической силой, и превращала его то в омерзительного ящера, то в змею, жалящую ядом прямо в сердце, 
        то в расплавленный металл, обжёгший руки и лицо Дженет. 
        Но она не отпустила его; и он снова стал человеком. 
      </p>
      <p class="mb-5">
        Он женился на Дженет, но скоро ему стало скучно со стареющей, изуродованной страшными ожогами Дженет. 
        Он вспомнил о ласках и всевластии королевы и вернулся к ней. 
        А Дженет… чтó Дженет? 
        Старая, уродливая – кому она нужна? 
        И кому теперь нужна её великая, изменившая жизнь их двоих любовь? 
      </p>

      <p class="mb-3">
        Таковы две истории о любви с двух разных концов света. 
      </p>
    

    </div>
    `
  )
}

const itemName = {
  rus: `Две великие истории о любви`
}

const itemDate = {
  rus: `14 сентября 2021 г.`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;